/*========GET CREDITS LIST========*/
export const GET_CREDIT_LOG_USER_SUCCESS   = 'GET_CREDIT_LOG_USER_SUCCESS';
export const GET_CREDIT_LOG_USER_FAIL      = 'GET_CREDIT_LOG_USER_FAIL';